import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { journalEntryService } from '@kss/api';
import type { JournalEntryCreate } from '@kss/api';
import { loadStoreOptions } from '../shared/formLoaders';

const columns: BulkColumn<JournalEntryCreate>[] = [
  { key: 'entryDate', header: 'Date', required: true, dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'reference', header: 'Reference', sample: 'JE-1001' },
  { key: 'description', header: 'Description' },
  { key: 'totalDebit', header: 'Total debit', dataType: 'number', parse: parseNum as never },
  { key: 'totalCredit', header: 'Total credit', dataType: 'number', parse: parseNum as never },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'isPosted', header: 'Posted', dataType: 'boolean', parse: parseBool as never, sample: 'false' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkJournalEntry() {
  return (
    <BulkSpreadsheet<JournalEntryCreate> title="Bulk import journal entries" entityLabel="journal entry" backPath="/panel/journal-entries" columns={columns} module="JournalEntry"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await journalEntryService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
